module.exports = __webpack_public_path__ + "img/apidays-ppt-2.d07e7aec.png";